const LoadCommentsByModeratorAction = {
    Request: 'LoadCommentsByModeratorActionRequest',
    Success: 'LoadCommentsByModeratorActionSuccess',
    Failure: 'LoadCommentsByModeratorActionFailure',
};const UpdateCommentAction = {
    Request: 'UpdateCommentActionByRequest',
    Success: 'UpdateCommentActionSuccess',
    Failure: 'UpdateCommentActionFailure',
};
const GetCommentAction = {
    Request: 'GetCommentActionRequest',
    Success: 'GetCommentActionSuccess',
    Failure: 'GetCommentActionFailure',
}

const UnloadCommentAction = {
    Request: 'UnloadCommentActionRequest',
    Success: 'UnloadCommentActionSuccess',
}
function loadCommentsByModerator(moderatorId) {
    return {
        type: LoadCommentsByModeratorAction.Request,
        payload: moderatorId
    }
}
function updateComment(comment) {
    return {
        type: UpdateCommentAction.Request,
        payload: comment,
    }
}
function getComment(id) {
    return {
        type: GetCommentAction.Request,
        payload: id,
    }
}
function unloadComment() {
    return {
        type: UnloadCommentAction.Request
    }
}

export const CommentActionCreators = {
    loadCommentsByModerator,
    updateComment,
    getComment,
    unloadComment
}

export const CommentActions = {
    LoadCommentsByModeratorAction,
    UpdateCommentAction,
    GetCommentAction,
    UnloadCommentAction
}
